import React, { Suspense } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SubExpiredModalStyle } from "./SubExpiredModal.style";
import Loader from "../loaders/pageLoader";

const SubExpiredModal = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <Modal show={showExp} centered={true}>
        <Modal.Body>
          <span className="me-4">{t("GENERAL.SUB_EXPIRED")}</span>
          <a href="https://t.me/edutizim_admin">@edutizim_admin</a>
        </Modal.Body>
      </Modal> */}
      <SubExpiredModalStyle>
        <div className="content">
          <span className="me-4">{t("GENERAL.SUB_EXPIRED")}</span>
          <a href="https://t.me/edutizim_admin">@edutizim_admin</a>
        </div>
      </SubExpiredModalStyle>
    </>
  );
};

export default SubExpiredModal;
